import { AfterViewInit, Component, inject, input, OnDestroy, ChangeDetectionStrategy } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { ExternalAuthService } from "../external-auth.service";


@Component({
	selector: 'firebaseui-part',
	imports: [],
	templateUrl: './firebaseui.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [` .firebaseui-container { background-color: transparent; }`]
})
export class FirebaseuiPart implements AfterViewInit, OnDestroy {

	private readonly auth = inject(ExternalAuthService);

	provider = input.required<Observable<"Google" | "Password">>();
	subscription: Subscription | undefined = undefined;

	ngAfterViewInit() {

		if (this.subscription) this.subscription.unsubscribe();
		this.subscription = this.provider().subscribe(this.auth.render.bind(this.auth));

	}

	ngOnDestroy() {
		if (this.subscription) this.subscription.unsubscribe();
	}



}